<template>
      <section class="not-found-wrapper">
        <div class="container">
          <div class="not-found-sec">
            <div class="found-img">
              <img src="@/assets/images/not-found.jpg" alt="error">
            </div>
            <div class="found-heading">
              <h1>404</h1>
              <p>Not Found</p>
              <router-link to="/" class="btn_submit_cl">Go To Homepage</router-link>
            </div>
          </div>
        </div>
      </section>
  </template>
  
  <script>
  export default {
    name: "NotFound",
  };
  </script>
  
  <style scoped>
  .not-found {
    text-align: center;
    margin-top: 50px;
  }
  .not-found-sec {
    height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    gap: 15px;
}
  
  .found-img img {
    max-width:200px;
  }
  
  .found-img{
  text-align:center;
  }
  
  .found-heading {
    text-align: center;
  }
  .not-found-wrapper{
    background-color:#fff;
  }
  
  .found-heading h1 {
    color: #000;
    font-size: 72px;
    font-weight: 900;
    line-height: 64px;
    margin: 0 0 5px;
  }
  
  .found-heading p {
    color: #404040;
    font-size: 30px;
    font-weight: 400;
  }
  
  .found-heading .btn_submit_cl {
    margin-top: 10px;
    display: inline-block;
    width: -moz-fit-content;
    width: fit-content;
    padding: .5rem 1rem;
    border-radius: 4px;
    background-color: var(--bs-secondary);
    color: #fff;
    font-size: .9rem;
    line-height: 1.5;
    font-weight: 600;
  }
  
  .align-items-center {
    align-items: center!important;
    background-color:#fff;
    flex-direction: column;
  }
  .heading-section {
    display: none;
}
footer.footer-menu {
    display: none;
}
  </style>
  